module.exports = __webpack_public_path__ + "img/swipe1.72cf66e3.png";